import React, { Component } from 'react'
import Navigation from '../../components/navigation'

class WelcomeRoute extends Component {
  render() {
    return (
      <div className="container">
        <Navigation activeStep={0} />
      </div>
    )
  }
}

export default WelcomeRoute